import { AxiosResponse } from 'axios';
import { put } from 'redux-saga/effects';
import { api } from '../../libs';
import {
  IChangePasswordAction,
  ILoginRequestAction,
  loginError,
  loginSuccess,
  logout,
} from '../actions/auth';

export function* loginSaga({ payload }: ILoginRequestAction) {
  try {
    const response = yield api.login(payload.phone, payload.code);
    const tokenExpiresAt = new Date();
    tokenExpiresAt.setTime(tokenExpiresAt.getTime() + 3600 * 48 * 1000);
    const userResponse: AxiosResponse = yield api.getMe();
    yield put(
      loginSuccess({
        user: userResponse.data.data,
        accessToken: response.access_token,
        refreshToken: response.refresh_token,
        expiresAt: tokenExpiresAt,
      })
    );
  } catch (err) {
    yield put(loginError(err.message));
  }
}

export function* changePasswordSaga(action: IChangePasswordAction) {
  try {
    yield api.changePassword(action.payload.oldPassword, action.payload.newPassword);
    yield put(logout());
  } catch (err) {
    yield put(loginError(err.message));
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/auth.ts